import Icon from './src/icon.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToIcon: SFCWithInstall<typeof Icon> = withInstall(Icon)

export default ToIcon

export { Icon }
export * from './src/icon.vue'
